import { useTheme } from '@emotion/react';
import { useAtom } from 'jotai';
import React, { useCallback } from 'react';

import { Flex, Pagination } from '~/components/blocks';
import { historyPageInfoState } from '~/state/partials/telemedicine_patient_profile/atoms';

export const HistoryPagination = () => {
  const theme = useTheme();

  const [pageInfo, setPageInfo] = useAtom(historyPageInfoState);
  const handleChangePage = useCallback(
    (page: number) => setPageInfo((_state) => ({ ..._state, page })),
    [setPageInfo],
  );

  return (
    <Flex justifyContent="center" marginTop={theme.space.l}>
      <Pagination
        currentPage={pageInfo.page}
        totalPage={pageInfo.totalPage}
        onChange={handleChangePage}
      />
    </Flex>
  );
};
